import { FaroRoutes } from '@grafana/faro-react';
import { NavLink, Route } from 'react-router-dom';
import { AdminPage } from './pages/AdminPage'
import { HomePage } from './pages/HomePage'
import './App.css'

function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <nav>
          <NavLink to="/" className="logo">
            Platform Jokes
          </NavLink>
          <div className="nav-links">
            <NavLink to="/" end>
              Home
            </NavLink>
            <NavLink to="/admin">Admin</NavLink>
          </div>
        </nav>
      </header>

      <main className="app-main">
        <FaroRoutes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </FaroRoutes>
      </main>

      <footer className="app-footer">
        <small>&copy; {new Date().getFullYear()} </small>
      </footer>
    </div>
  )
}

export default App
